import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Btn } from "@/components/ui/Btn/Btn";
import { Icon } from "@/components/ui/Icon/Icon";
import { Input } from "@/components/ui/Input/Input";
import { AppShell } from "@/components/app/AppShell";
import { Field } from "@/components/auth/FormShell";
import { useAuth } from "@/lib/AuthContext";
import { useCreateWorkspace } from "@/lib/queries";
import { setLastWorkspaceId } from "@/lib/workspacePref";
import styles from "./NewWorkspace.module.css";

export function NewWorkspace() {
  const auth = useAuth();
  const navigate = useNavigate();
  const createWorkspace = useCreateWorkspace();
  const [name, setName] = useState("");

  if (auth.status === "anonymous") {
    return <Navigate to="/signin?next=/app/new-workspace" replace />;
  }

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    const result = await createWorkspace.mutateAsync({ name: name.trim() });
    setLastWorkspaceId(result.workspace.id);
    navigate(`/w/${result.workspace.id}`, { replace: true });
  }

  return (
    <AppShell>
      <div className={styles.page}>
        <div className={styles.card}>
          <span className={styles.mark} aria-hidden="true">✦</span>
          <h1 className={styles.title}>Create a workspace</h1>
          <p className={styles.body}>
            A workspace holds your brands and your team. You can rename it later and
            invite people once you’re set up.
          </p>
          <form onSubmit={onSubmit} className={styles.form}>
            {createWorkspace.error && (
              <p className={styles.error}>{createWorkspace.error.message}</p>
            )}
            <Field label="Workspace name" htmlFor="ws-name">
              <Input
                id="ws-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your company or team name"
                autoFocus
                maxLength={80}
              />
            </Field>
            <Btn
              type="submit"
              variant="primary"
              full
              size="lg"
              disabled={!name.trim()}
              loading={createWorkspace.isPending}
              iconRight={<Icon name="arrow-right" size={14} />}
            >
              Create workspace
            </Btn>
          </form>
        </div>
      </div>
    </AppShell>
  );
}
